
window.addEventListener('load', () => {
    const burger = document.querySelector(`[data-nav="burger"]`),
        menuContainer = document.querySelector(`[data-nav="menuContainer"]`);

    menuContainer.setAttribute('data-nav-visibility', 'hidden');

    burger.addEventListener('click', () => {
        const isVisible = menuContainer.getAttribute('data-nav-visibility');

        if (isVisible === 'hidden') {
            menuContainer.classList.add('show');
            burger.classList.add('open');
            menuContainer.setAttribute('data-nav-visibility', 'visible');
        } else {
            menuContainer.classList.remove('show');
            burger.classList.remove('open');
            menuContainer.setAttribute('data-nav-visibility', 'hidden');
        }
    })
});
